import * as React from 'react';

import Loader from '../Loader/Loader';

interface Props {
  children: any;
  on?: any;
}

export default class Async extends React.Component<Props> {
  static defaultProps = {
    on: false,
  };

  render() {
    return (
      <div className={`async${this.props.on ? '' : ' active'}`}>
        {!Boolean(this.props.on) && <Loader />}
        <div className="async__container">{this.props.children}</div>
      </div>
    );
  }
}
